export default import.meta.ROLLDOWN_FILE_URL_eU7CJFIXHKHc1T1eVB7ANA